import { P2 } from '@repo/ui/components/Typography';
import { hideScrollBar } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { HORIZONTAL_PADDING_MOBILE } from '../../utilities/pageStyles';

export const PricingTable = styled.div`
  margin: 0 auto;
  overflow: hidden;

  ${QUERIES.tabletAndUp} {
    overflow: initial;
    width: fit-content;
    margin: 0 auto;
  }
`;

export const PlanContainersWrapper = styled.div<{
  plans: number;
}>`
  display: grid;
  ${({ plans }) => `grid-template-rows: repeat(${plans}, 1fr);`}
  padding: '6px 0px;';

  overflow-x: scroll;
  scroll-snap-type: x mandatory;

  ${hideScrollBar}

  ${QUERIES.tabletAndUp} {
    grid-template-rows: none;
    grid-template-columns: ${({ plans }) =>
      plans === 4 ? 'repeat(4, 292px)' : 'repeat(3, 368px)'};
    gap: 24px;
    justify-content: center;
  }

  ${QUERIES.smallDesktopAndUp} {
    overflow-x: initial;
  }
`;

export const NarrowContentWrapper = styled.div`
  width: 888px;
  max-width: 100%;
  margin: 0 auto;
`;

// we hide comparison when we can't fully display it
export const ComparisonWrapper = styled.div`
  width: 1000px;
  max-width: 100%;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1211px) {
    display: none;
  }
`;

export const VatNotice = styled(P2)`
  padding: 0 ${HORIZONTAL_PADDING_MOBILE};

  ${QUERIES.tabletAndUp} {
    padding: 0;
  }
`;
